"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addDefaultFiltersForContentSearch = void 0;
const __enums_1 = require("../../../__types/__enums");
const checkIfFilterExists = (filters, name) => filters.find(item => item.name === name);
function addUnpublishFilter(filters) {
    const unpublishFilter = [
        { name: __enums_1.ContentFilterEnum.UNPUBLISHED, type: __enums_1.ElasticsearchFilterTypeEnum.MUST, values: [false] }
    ];
    filters.push(...unpublishFilter);
}
function addDraftFilter(filters) {
    const draftFilter = [
        { name: __enums_1.ContentFilterEnum.DRAFT, type: __enums_1.ElasticsearchFilterTypeEnum.MUST, values: [false] }
    ];
    filters.push(...draftFilter);
}
function addDefaultFiltersForContentSearch(contentFilters = []) {
    const unpublishFilterExists = checkIfFilterExists(contentFilters, __enums_1.ContentFilterEnum.UNPUBLISHED);
    const draftFilterExists = checkIfFilterExists(contentFilters, __enums_1.ContentFilterEnum.DRAFT);
    if (!unpublishFilterExists && !draftFilterExists) {
        addUnpublishFilter(contentFilters);
        addDraftFilter(contentFilters);
    }
}
exports.addDefaultFiltersForContentSearch = addDefaultFiltersForContentSearch;
//# sourceMappingURL=addFilters.js.map